import { Link, generatePath } from 'react-router-dom'
import styled from 'styled-components'

import { fromGlobalId } from 'utils/transformations/graphql'

import { EMPTY_CELL_CONTENT } from 'shop/products/utils'

import { NEW_ORDER_REVIEW } from 'routes/paths'

import { PaymentTypes, TableRowData } from '../joorPayOrders.types'

export function PONumberCell({
  value,
  data,
}: {
  value: string
  data: TableRowData
}) {
  if (value === EMPTY_CELL_CONTENT) return <>{value}</>

  const paymentType = data.type

  const orderId = data.id && fromGlobalId(data.id).id

  const to =
    paymentType === PaymentTypes.JoorPayment && orderId
      ? generatePath(NEW_ORDER_REVIEW, { id: orderId }).concat('?tab=pay')
      : '/orders'

  return (
    <StyledLink to={to} target="_blank">
      {value}
    </StyledLink>
  )
}

const StyledLink = styled(Link)`
  color: var(--color-secondary-800) !important;
`
